export const TRANSLATION_KEY = 'notice';
